export default __webpack_public_path__ + "static/media/fb_mobile2.c1f06404.png";